import IAmount from "./IAmount";
import Currency from "../CurrencyCodeEnum";

export default class Amount implements IAmount {
    constructor(public amount: number = 0, public currency: Currency = Currency.CZK) {
    }
}
